import React from "react";
import { GiSettingsKnobs } from "react-icons/gi";
import { useLocation } from "react-router-dom";

function formatDate(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

const ViewDetails = () => {
  const location = useLocation();
  const { item } = location.state || {};

  return (
    <div className="addUserManagementContainer">
      <div className="addUserManagementHeader">
        <div className="addUserHeaderLeft">
          <GiSettingsKnobs
            size={30}
            color="#ff0000"
            style={{ marginRight: 10 }}
          />
          <h2>User Details</h2>
        </div>
      </div>
      <div className="addUserProfileContainer">
        <h3>User Profile</h3>
        <div className="addUserProfileMain">
          <p>Basic Information :</p>
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label>Member ID</label>
              <input type="text" value={item?.memberId} readOnly />
            </div>
            <div className="addUserProfileInput">
              <label>Full Name</label>
              <input type="text" value={item?.fullName || ""} readOnly />
            </div>
          </div>
          <div className="addUserProfileInputMain">
            <div className="addUserListInput">
              <label>Email ID</label>
              <input type="text" value={item?.email || ""} readOnly />
            </div>
            <div className="addUserListInput">
              <label>Phone No</label>
              <input type="text" value={item?.phoneNo || ""} readOnly />
            </div>
          </div>
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label htmlFor="gender">Gender</label>
              <input type="text" value={item?.gender || ""} readOnly />
            </div>
            <div className="addUserProfileInput">
              <label>Age</label>
              <input type="text" value={item?.age || ""} readOnly />
            </div>
          </div>
          <div className="addUserProfileInputMain">
            <div className="addUserListInput">
              <label>Address</label>
              <input type="text" value={item?.address || ""} readOnly />
            </div>
            <div className="addUserListInput">
              <label>Date of birth</label>
              <input type="text" value={formatDate(item?.dob)} readOnly />
            </div>
          </div>
          <div className="addUserProfileInputMain">
            <div className="addUserListInput">
              <label>Bill Date</label>
              <input
                type="text"
                value={formatDate(item?.billDate) || ""}
                readOnly
              />
            </div>
          </div>
        </div>
      </div>

      <div className="addUserMemberContainer">
        <h3>Membership Details:</h3>
        <div className="addUserListMain">
          <div className="addUserListInputMain">
            <div className="addUserListInput">
              <label>Membership Start Date</label>
              <input
                type="text"
                value={formatDate(item?.membershipStartDate) || ""}
                readOnly
              />
            </div>
            <div className="addUserListInput">
              <label>Renewal/Expiry Date</label>
              <input
                type="text"
                value={formatDate(item?.renewalExpiryDate) || ""}
                readOnly
              />
            </div>
          </div>
          <div className="addUserListInputMain">
            <div className="addUserProfileInput">
              <label htmlFor="package">Membership Package</label>
              <input type="text" value={item?.package || ""} readOnly />
            </div>
            <div className="addUserListInput">
              <label>Billing Amount</label>
              <input type="text" value={item?.billingAmount || ""} readOnly />
            </div>
          </div>
          <div className="addUserListInputMain">
            <div className="addUserProfileInput">
              <label>Payment Mode</label>
              <input type="text" value={item?.paymentMode || ""} readOnly />
            </div>
            <div className="addUserProfileInput">
              <label>Trainer Assignment</label>
              <input type="text" value={item?.trainerId || ""} readOnly />
            </div>
          </div>
        </div>
      </div>
      <div className="addUserMemberContainer">
        <h3>GST Details Section:</h3>
        <div className="addUserListMain">
          <div className="addUserListInputMain">
            <div className="addUserListInput">
              <label>GST Number</label>
              <input type="text" value={item?.gstNumber || ""} readOnly />
            </div>
            <div className="addUserListInput">
              <label>Company/Business Name </label>
              <input type="text" value={item?.companyName || ""} readOnly />
            </div>
          </div>
          <div className="addUserListInputMain">
            <div className="addUserListInput">
              <label>Billing Address</label>
              <input type="text" value={item?.billingAddress || ""} readOnly />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDetails;
